import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MeetingCancellationReasonResponse } from '../models/meeting.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface CancellationReasonDrawerOptions {
  reasonId?: number;
}

@Injectable({ providedIn: 'root' })
export class MeetingCancellationReasonDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: CancellationReasonDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  private readonly saved$$ = new Subject<MeetingCancellationReasonResponse>();

  readonly state = this.state$.asObservable();
  readonly saved$ = this.saved$$.asObservable();

  open(options: CancellationReasonDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(item: MeetingCancellationReasonResponse): void {
    this.saved$$.next(item);
  }
}
